const API_URL = process.env.API_URL

module.exports = { API_URL }
